import React, { useState } from 'react';

import { FormControl, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material';

import HomepageMetrics from './HomepageMetrics';
import LegacyHomepageMetrics from './LegacyHomepageMetrics';

type Homepage = 'CURRENT' | 'LEGACY';

export default function HomepageMetricsTab() {
  const [homepage, setHomepage] = useState<Homepage>('CURRENT');
  return (
    <Stack spacing={3}>
      <Typography variant="h5" fontWeight="bold">
        Homepage Metrics
      </Typography>
      <FormControl size="small" sx={{ width: 260 }}>
        <InputLabel id="homepage-metrics-label">Homepage</InputLabel>
        <Select
          labelId="homepage-metrics-label"
          label="Homepage"
          value={homepage}
          onChange={(event) => {
            if (event.target.value === 'CURRENT' || event.target.value === 'LEGACY') {
              setHomepage(event.target.value);
            }
          }}
        >
          <MenuItem value="CURRENT">Current homepage</MenuItem>
          <MenuItem value="LEGACY">Previous homepage</MenuItem>
        </Select>
      </FormControl>
      {homepage === 'CURRENT' ? <HomepageMetrics /> : <LegacyHomepageMetrics />}
    </Stack>
  );
}
